import { ApiResponse } from 'apisauce';
import { Api } from '../api/api';
import { TGeneralApiResponse } from '../api/api-problem';
import { IResponseSnapshot } from '../../models';

/**
 * # CommonCode Api 서비스
 *
 * 서비스의 설명을 작성하세요.
 *
 * ## 사용방법
 *
 * ```ts
 * const service = new CommonCodeApi();
 *
 * ```
 */
export class CommonCodeApi {
  private api: Api;

  private BASE_URL = '/commonCode';

  constructor(api: Api) {
    this.api = api;
    this.api.setup();
  }

  /** CdssCodes 공통 코드 리스트 조회 */
  async getCdssCodes(): Promise<TGeneralApiResponse> {
    try {
      const url = `${this.BASE_URL}/list`;
      const response: ApiResponse<any> = await this.api.apisauce.get(url);
      const responseInfo: IResponseSnapshot = response.data;

      return { kind: 'ok', responseInfo: responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }
}
